<template>
  <div class="w-full h-fit flex flex-col items-center justify-center p-lg border-border border-3 border-solid rounded-2xl">
    <div class="flex items-center justify-center mb-base">
      <slot name="icon" />
    </div>
    <h2
      class="text-black text-20"
      data-test="title"
    >
      {{ title }}
    </h2>
    <div class="empty-state-content">
      <slot name="content"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomIconEmptyState',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

